<div *ngFor="let toaster of toasts" class="{{ cssClass(toaster) }} alert-dismissable">
    <div class="colab-alert right-top" (click)="removeAlert(toaster)">
        <div class="wrp-icon">
            <svg version="1.1" id="Camada_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 75.9 75.9" style="enable-background:new 0 0 75.9 75.9;" xml:space="preserve">
            <style type="text/css">
                .st0{fill:#F6ECC0;}
                .st1{fill:none;stroke:#E2C02D;stroke-width:3;stroke-miterlimit:10;}
                .st2{fill:#FFFFFF;}
                .st3{fill:none;stroke:#E2C02D;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}
            </style>
            <path class="st0" d="M74,37.9c0,19.8-16.1,35.9-35.9,35.9S2.2,57.7,2.2,37.9C2.2,18.1,18.3,2,38.1,2S74,18.1,74,37.9"/>
            <path class="st1" d="M74,37.9c0,19.8-16.1,35.9-35.9,35.9S2.2,57.7,2.2,37.9C2.2,18.1,18.3,2,38.1,2S74,18.1,74,37.9z"/>
            <path class="st2" d="M66.5,37.9c0,15.7-12.7,28.4-28.4,28.4c-15.7,0-28.4-12.7-28.4-28.4c0-15.7,12.7-28.4,28.4-28.4 C53.8,9.5,66.5,22.2,66.5,37.9"/>
            <path class="st1" d="M66.5,37.9c0,15.7-12.7,28.4-28.4,28.4c-15.7,0-28.4-12.7-28.4-28.4c0-15.7,12.7-28.4,28.4-28.4 C53.8,9.5,66.5,22.2,66.5,37.9z"/>
            <polyline class="st3" points="38.1,20.1 38.1,37.9 47.2,45.8 "/>
            </svg>
        </div>
        <div class="wrp-text">
            <h3>{{getTitle(toaster)}}</h3>
            <p [innerHTML]="toaster.message"></p>
        </div>
    </div>
</div>